import ControlInstaller from './Controls'
import SampleModal from './Modals/SampleModal'
import SuccessModal from './Modals/SuccessModal'
import RedirectModal from './Modals/RedirectModal'
import GoogleMapModal from './Modals/GoogleMapModal'
import ToggleMixinModal from './Modals/mixins/ToggleMixinModal'

Vue.use(ControlInstaller)
Vue.component(SampleModal.name, SampleModal)
Vue.component(SuccessModal.name, SuccessModal)
Vue.component(RedirectModal.name, RedirectModal)
Vue.component(GoogleMapModal.name, GoogleMapModal)
Vue.component(ToggleMixinModal.name, ToggleMixinModal)

import './Common'
import './Modules'
import './Input'
import './Forms'
import './Order'
import './Tables'
import './Uploader'



// WEBPACK FOOTER //
// ./src/js/components/index.js